import { Component, inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { ApiService } from '../../../Services/api.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-update-attributes',
  standalone: true,
  imports: [ReactiveFormsModule, NzButtonModule, NzFormModule, NzInputModule, FormsModule, NzLayoutModule, NzRadioModule,
    NzCheckboxModule, CommonModule],
  templateUrl: './update-attributes.component.html',
  styleUrl: './update-attributes.component.scss'
})
export class UpdateAttributesComponent implements OnInit {

  catalogDetails: any;
  @Input() catalogId: string = '';
  attributeForm: FormGroup = new FormGroup({});
  invalidForm: boolean = false;
  constructor(private apiService: ApiService, private fb: FormBuilder) {
  }

  ngOnInit() {
    this.apiService.getCatalogDetail(this.catalogId).subscribe(res => {
      this.catalogDetails = res;
      this.initForm();
    })

  }

  initForm() {
    this.attributeForm = this.fb.group({
      catalogDesc: [this.catalogDetails.catalogDesc],
      catId: [this.catalogId],
      enableCatMap: [false],
      checkCloseOut: [this.catalogDetails.checkCloseOut == 0 ? false : true],
      minimumInventory: [this.catalogDetails.minimumInventory],
      emailAddress: [this.catalogDetails.emailAddress],
      allowCloseOut: [this.catalogDetails.allowCloseOut == 0 ? false : true],
      allowKeywordSearch: [this.catalogDetails.allowKeywordSearch == 0 ? false : true],
      multiLotUpdate: [this.catalogDetails.multiLotUpdate == 0 ? false : true],
      checkoutMsg: [this.catalogDetails.checkoutMsg],
      notifyOptionalCustomize: [this.catalogDetails.notifyOptionalCustomize == 0 ? false : true],
      allowAddLettering: [this.catalogDetails.allowAddLettering == 0 ? false : true],
      notifyRemainingAllowance: [this.catalogDetails.notifyRemainingAllowance == 0 ? false : true],
      shipToAddrPopUp: [this.catalogDetails.shipToAddrPopUp]
    });

    if (this.catalogDetails.shipToAddrPopUp == 3) {
      this.attributeForm.get('checkoutMsg')?.enable();
    }
    else {
      this.attributeForm.get('checkoutMsg')?.disable();
    }
    if (this.attributeForm.get('checkCloseOut')?.value == true) {
      this.attributeForm.get('emailAddress')?.enable({ emitEvent: false });
      this.attributeForm.get('minimumInventory')?.enable({ emitEvent: false });
    }
    else {
      this.attributeForm.get('emailAddress')?.disable({ emitEvent: false });
      this.attributeForm.get('minimumInventory')?.disable({ emitEvent: false });
    }

    this.attributeForm.get('shipToAddrPopUp')?.valueChanges.subscribe(value => {
      if (value == 3) {
        this.attributeForm.get('checkoutMsg')?.enable();
      }
      else {
        this.attributeForm.get('checkoutMsg')?.disable();
      }
    });
    this.attributeForm.get('checkCloseOut')?.valueChanges.subscribe(val => {
      if (val) {
        this.attributeForm.get('emailAddress')?.enable({ emitEvent: false });
        this.attributeForm.get('minimumInventory')?.enable({ emitEvent: false });

      } else {
        this.attributeForm.get('emailAddress')?.disable({ emitEvent: false });
        this.attributeForm.get('emailAddress')?.setValue(this.catalogDetails.emailAddress);
        this.attributeForm.get('minimumInventory')?.disable({ emitEvent: false });
        this.attributeForm.get('minimumInventory')?.setValue(this.catalogDetails.minimumInventory);

      }

      this.attributeForm.get('emailAddress')?.updateValueAndValidity();
      this.attributeForm.get('minimumInventory')?.updateValueAndValidity();
    });


  }

  updateForm() {
    if (!this.attributeForm.get('catalogDesc')?.value) {
      this.invalidForm = true;
      return
    }
    this.invalidForm = false;

    this.catalogDetails["catalogDesc"] = this.attributeForm.get('catalogDesc')?.value;
    this.catalogDetails["checkCloseOut"] = !this.attributeForm.get('checkCloseOut')?.value ? 0 : 1;
    this.catalogDetails["minimumInventory"] = this.attributeForm.get('minimumInventory')?.value;
    this.catalogDetails["emailAddress"] = this.attributeForm.get('emailAddress')?.value;
    this.catalogDetails["allowCloseOut"] = !this.attributeForm.get('allowCloseOut')?.value ? 0 : 1;
    this.catalogDetails["allowKeywordSearch"] = !this.attributeForm.get('allowKeywordSearch')?.value ? 0 : 1;
    this.catalogDetails["multiLotUpdate"] = !this.attributeForm.get('multiLotUpdate')?.value ? 0 : 1;
    this.catalogDetails["shipToAddrPopUp"] = this.attributeForm.get('shipToAddrPopUp')?.value;
    this.catalogDetails["checkoutMsg"] = this.attributeForm.get('checkoutMsg')?.value;
    this.catalogDetails["notifyOptionalCustomize"] = !this.attributeForm.get('notifyOptionalCustomize')?.value ? 0 : 1;
    this.catalogDetails["allowAddLettering"] = !this.attributeForm.get('allowAddLettering')?.value ? 0 : 1;
    this.catalogDetails["notifyRemainingAllowance"] = !this.attributeForm.get('notifyRemainingAllowance')?.value ? 0 : 1;

    this.apiService.updateCatalogDetail(this.catalogDetails).subscribe(res => {
      this.apiService.createNotification('success', res?.message);
      this.ngOnInit();
    }, err => {
      this.apiService.createNotification('error', err?.error?.message);
    })
  }

    trimCatalogDesc() {
  const control = this.attributeForm.get('catalogDesc');
  if (control && control.value) {
    // .trim() removes spaces from both the beginning and end of the string
    const trimmedValue = control.value.trim();
    
    // updateValueAndValidity ensures validators rerun after trimming
    control.setValue(trimmedValue);
    control.updateValueAndValidity();
  }
}



}
